var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "user.name",
      label: "评论人",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "otherUser.name",
      label: "被评论人",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "content",
      label: "评论内容"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "create",
      label: "评论时间",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "100",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(scope.row);
            }
          }
        }, [_vm._v("删除")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };